import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import StageCaptureReceiver from './components/StageCaptureReceiver';
import { SessionStoreProvider } from './contexts/SessionStore';
import { AuthProvider } from './contexts/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import ConnectionBanner from './components/ConnectionBanner';
import { sofortAufraeumen } from './lib/browserSpeicher';
import { verkleinereGespeichertenAuftrag } from './components/GuideSendQueue';
import { wendeFarbschemaAn } from './lib/farbschema';
import { entwurfsLebenszeichenStarten } from './lib/gesicherterEntwurf';
import './styles/tokyo-night.css';
import './styles/feste-farben.css';
import './styles/responsive.css';
import 'flexlayout-react/style/dark.css';

// Tag/Nacht vor dem ersten Zeichnen setzen (lib/farbschema.ts), sonst blitzt der dunkle Modus auf.
wendeFarbschemaAn();
// Lebenszeichen dieses Fensters ab dem Laden — sonst gaelten Mission-Control-Entwuerfe eines
// neu geladenen Fensters ohne offenes Mission Control nach 90 s als verwaist (lib/gesicherterEntwurf).
entwurfsLebenszeichenStarten();

// Keep old mobile bookmarks usable without selecting a separate interface.
// Preserve unrelated query parameters and the hash (panel and workspace links).
const url = new URL(window.location.href);
if (url.searchParams.has('mobile') || url.searchParams.get('mode') === 'mobile') {
  url.searchParams.delete('mobile');
  if (url.searchParams.get('mode') === 'mobile') url.searchParams.delete('mode');
  window.history.replaceState(window.history.state, '', url.toString());
}

// Einmal je Browser: Speicher-Caches raeumen, Sendeauftraege schrumpfen (lib/browserSpeicher.ts).
// Laut in beide Richtungen: was entfernt wurde, steht im Log; scheitert der Lauf, auch.
try {
  const bericht = sofortAufraeumen(localStorage, verkleinereGespeichertenAuftrag);
  if (bericht) console.warn(`[speicher] Sofort-Aufräumung: ${bericht.entfernt} Cache-Einträge entfernt, ${bericht.verkleinert} Sendeaufträge verkleinert${bericht.unlesbar ? `, ${bericht.unlesbar} unlesbar und unangetastet` : ''} — ${bericht.kbVorher} KB vorher, ${bericht.kbNachher} KB nachher.`);
} catch (err) { console.error('[speicher] Sofort-Aufräumung gescheitert — der Speicher bleibt, wie er war:', err); }

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary componentName="App">
      <AuthProvider>
        <SessionStoreProvider>
          <StageCaptureReceiver />
          <ConnectionBanner />
          <App />
        </SessionStoreProvider>
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>
);
